import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { DriverVehicleCard } from './DriverVehicleCard';
import { PrimaryButton } from '../../components/button/PrimaryButton';
import { Spinner } from '../../components/Spinner';
import { useFetchDriver } from '../../hooks/useFetchDriver';
import { useInfiniteFetchVehiclesForDriver } from '../../hooks/useFetchVehiclesForDriver';
import { t } from '../../services/translation/translation';

export const DriverVehiclesCards = () => {
  const { driverKey } = useParams();

  invariant(driverKey);

  const { data: driver } = useFetchDriver(driverKey);

  const [searchParams] = useSearchParams();
  const orderBy = searchParams.get('orderBy') ?? 'resume.departureAt';
  const direction = (searchParams.get('direction') ?? 'desc') as 'desc' | 'asc';

  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } = useInfiniteFetchVehiclesForDriver(
    driverKey,
    {
      direction,
      orderBy,
    },
  );

  const vehicles = useMemo(() => data?.pages.map(p => p.items).flat() || [], [data]);

  return (
    <div>
      <div className="p-5 text-lg font-semibold text-left text-gray-900 bg-white dark:text-white dark:bg-gray-800">
        <div className="flex gap-2 items-start">
          <div className="flex-1">
            {t('vehicles-route.table-title')}
            <p className="mt-1 text-sm font-normal text-gray-500 dark:text-gray-400">
              {t('driver-route.vehicle-list-description')}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div className="space-y-2">
          {vehicles.map(vehicles => (
            <DriverVehicleCard key={vehicles.id} vehicle={vehicles} driver={driver} />
          ))}
        </div>

        <div>
          {hasNextPage ? (
            <div className="flex justify-center mt-3">
              <PrimaryButton
                onClick={() => {
                  fetchNextPage();
                }}
                isLoading={isFetchingNextPage}
              >
                {t('common.see-more')}
              </PrimaryButton>
            </div>
          ) : null}
          <div>{isLoading ? <Spinner /> : null}</div>
        </div>
      </div>
    </div>
  );
};
